// src/app/manufacturer.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Manufacturer } from '../objects/Manufacturer';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ManufacturerService { 
  private apiUrl = environment.apiUrl +'Manufacturers'; // Replace with your API endpoint

  constructor(private http: HttpClient) {}

  getManufacturers(): Observable<Manufacturer[]> {
    return this.http.get<Manufacturer[]>(this.apiUrl);
  }

  getManufacturerById(id: number): Observable<Manufacturer> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<Manufacturer>(url);
  }

  addManufacturer(manufacturer: Manufacturer): Observable<Manufacturer> {
    return this.http.post<Manufacturer>(this.apiUrl, manufacturer);
  }

  editManufacturer(manufacturer: Manufacturer): Observable<Manufacturer> {
    const url = `${this.apiUrl}/${manufacturer.id}`;
    return this.http.put<Manufacturer>(url, manufacturer);
  }

  deletetManufacturer(manufacturer: Manufacturer): Observable<Manufacturer> {
    const url = `${this.apiUrl}/${manufacturer.id}`;
    return this.http.delete<Manufacturer>(url);
  }
}
